<p-toast key="message" position="top-right"></p-toast>
<p-confirmDialog [style]="{width: '90%', maxWidth: '450px'}" [baseZIndex]="10000"></p-confirmDialog>
<p-scrollTop [threshold]="300" [style]="{ bottom: '5rem' }" icon="pi pi-arrow-up"></p-scrollTop>

<router-outlet></router-outlet>
